import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,

        page: null
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        setPage(state, page) {
            state.page = page;
        }
    },

    actions: {
        load(context, pageId) {
            context.commit('setPage', null);
            context.commit('setLoading', true);

            return HTTP.get('/pages/' + pageId)
                .then(resp => {
                    context.commit('setPage', resp.data);
                    context.commit('setLoading', false);
                })
                .catch(err => context.commit('error/set', err.response, { root: true }));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/page.js